module.exports = {"500120001":"璧城街道","500120002":"璧泉街道","500120003":"青杠街道","500120004":"来凤街道","500120005":"丁家街道","500120006":"大路街道","500120100":"八塘镇","500120101":"七塘镇","500120102":"河边镇","500120103":"福禄镇","500120104":"大兴镇","500120105":"正兴镇","500120106":"广普镇","500120107":"三合镇","500120108":"健龙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500120.json
// module id = 2231
// module chunks = 0